import axios, { AxiosError } from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';
import { Supplier } from '@/types/supplier';

/** Получение поклажедателя */
export const getSuppliers = async () => {
	const token = cookies.get(TOKEN_COOKIE_NAME);
	const headers = token ? { Authorization: `Bearer ${token}` } : {};

	try {
		const { data } = await axios.get<Supplier[]>(`${process.env.HOST}/api_v1/depositors/`, {
			headers,
		});
		return data;
	} catch (error) {
		if (error instanceof AxiosError) {
			console.log(error?.response?.data);
		} else {
			console.log(error);
		}
	}
};
